export const convertRadiansToDegrees = (radians: number) => radians * (180 / Math.PI);

export const convertDegreesToRadians = (degrees: number) => degrees * (Math.PI / 180);
